import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Chip,
  Stack,
  List,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import NearMeIcon from "@mui/icons-material/NearMe";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CustomButton from "../shared/CustomButton";

const ALL_COLORS = [
  "#b9d3fa",
  "#fabdb9",
  "#b9fabd",
  "#faf2b9",
  "#fab9c4",
  "#c1b9fa",
  "#f6fab9",
  "#b9d3fa",
  "#fabdb9",
  "#b9fabd",
];

const data = [
  {
    id: 1,
    title: "Gadset - Full stack developer",
    Link: "https://tamboola.in/",
    skills: ["Reactjs", "Nodejs", "Express", "MongoDB"],
    description: [
      `Built a React.js frontend app for a device repairing website, a bidding
system - through which users can book a repairing agent in 5 steps`,
      `Created a partner app, allowing partners to quote on bids and track their
orders in 6 stages, fostering efficient collaboration.`,
      `Established a Node.js backend server connected to MongoDB, enabling
real-time bidding, connecting customer and partner app.`,
    ],
    time: "May 2023 - August 2023",
  },
  {
    id: 2,
    title: "Pladex - Full stack developer",
    Link: "http://pladex.in/",
    skills: ["Reactjs", "Nodejs", "Express", "MongoDB"],
    description: [
      "Developed Frontend- React js server with the help of Bootstrap,Rendering dynamic Content with transition effects",
      "Developed Node js backend servers handling of User and Books database. Operations like sort, Filter, and Upload are implemented.",
    ],
    time: "Dec 2020 - August 2021",
    images: [
      require("../images/pladex/pladex1.png"),
      require("../images/pladex/pladex2.png"),
      require("../images/pladex/pladex3.png"),
    ],
  },
  {
    id: 3,
    title: "Charkhi-dadri Info- Android App",
    Link: "https://play.google.com/store/apps/details?id=com.dadri",
    time: "July 2021 - Dec 2021",
    skills: ["React-Native", "Firebase", "Bootstrap"],
    description: [
      "Designed and Developed a Telephone Directory App which Contains all the information(Market, Shops, Hospitals, Schools..) of Charkhi-Dadri City Which in the future can be extended to other cities.",
      "Features like Userlogin(Firebase authentication), Bookmarks, and Advertising are implemented to increase Userinteraction . Data is being transferred to Firebase from Google sheets .",
    ],
    images: [
      require("../images/charkhi/dadri1.jpg"),
      require("../images/charkhi/dadri2.jpg"),
      require("../images/charkhi/dadri3.jpg"),
      require("../images/charkhi/dadri4.jpg"),
      require("../images/charkhi/dadri5.jpg"),
      require("../images/charkhi/dadri6.jpg"),
    ],
  },
  {
    id: 4,
    title: "Advanced Agenda Setter",
    Link: "http://venkateshjnv123.pythonanywhere.com/",
    time: "June 2020 - Nov 2020",
    skills: ["Django", "Sqlite", "Bootstrap"],
    description: [
      "Todo app with advanced features like prioritizing, sorting, editing, completing and removing",
      "Login and Logout features are enabled forindividual user experiences",
      "Connected to the sqlite database which gives more flexibility forreading and writing the todos and can be used as a app",
    ],
    images: [
      require("../images/pladex/pladex1.png"),
      require("../images/pladex/pladex2.png"),
      require("../images/pladex/pladex3.png"),
    ],
  },
  {
    id: 5,
    title: "HKNN algorithm and Tag prop",
    time: "June 2020 - August 2020",
    skills: ["Machine learning"],
    description: [
      "An improvement to the NN Algorithm -HKNN, where k-local Hyperplane is used to calculate the distance between the sections. convex-hull solution and weight-decay solutions are proposed for arising problems.",
      "Tag-prop is a rank-based model to annotate images based on weights and nearest neighbor algorithm.",
    ],
    images: [
      require("../images/pladex/pladex1.png"),
      require("../images/pladex/pladex2.png"),
      require("../images/pladex/pladex3.png"),
    ],
  },
  {
    id: 6,
    title: "BAJA SAE INDIA",
    skills: ["Solidworks", "Ansys", "Matlab"],
    time: "June 2021 - April 2022",
    description: [
      "Design and develop braking system",
      "DESIGN AND ANALYSIS OF BRAKE DISC AND PEDAL ",
      "CALCULATING THE BRAKING PARAMETERS.",
    ],
    images: [
      require("../images/pladex/pladex1.png"),
      require("../images/pladex/pladex2.png"),
      require("../images/pladex/pladex3.png"),
    ],
  },
];

function ProjectsNew() {
  const [flipped, setFlipped] = useState(Array(data.length).fill(false));
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to update the width
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener

    // hover code :
    // group-hover:shadow-2xl group-hover:scale-105
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleFlip = (index) => {
    const newFlipped = Array(data.length).fill(false);
    newFlipped[index] = true;
    setFlipped(newFlipped);
  };

  const handleBack = (index) => {
    const newFlipped = [...flipped];
    newFlipped[index] = false;
    setFlipped(newFlipped);
  };

  return (
    <Box className="flex flex-col">
      <CustomButton>
        <Typography variant="h6" sx={{ fontFamily: "Crimson Text, serif" }}>
          Projects{" "}
        </Typography>
      </CustomButton>
      <div className="flex flex-row flex-wrap w-full">
        {data.map((item, index) => (
          <div
            key={index}
            className={`relative transform transition-transform duration-700 ${
              width < 850 ? "w-screen" : "w-2/5"
            } max-h-70 group ${flipped[index] ? "rotate-y-180" : ""}`}
          >
            <Box
              className={`bg-gray-700 p-6 mt-4 ${
                width < 850 ? "" : "mr-4"
              } rounded-lg h-70 text-white shadow-lg  ${
                flipped[index] ? "hidden" : ""
              }`}
            >
              <div className="text-gray-500 mb-3 flex items-center">
                <DateRangeIcon />
                <span className="ml-2">{item.time}</span>
              </div>
              <div className="flex justify-between items-center mb-3">
                <Typography variant="h6" className="font-bold">
                  {item.title}
                </Typography>
                {/* {item.Link && (
                  <IconButton href={item.Link}>
                    <NearMeIcon className="text-blue-500" />
                  </IconButton>
                )} */}
              </div>
              <Stack direction="row" className="flex flex-wrap">
                {item.skills.map((skill, i) => (
                  <Chip
                    key={i}
                    label={skill}
                    className="font-bold mr-1 mt-1"
                    style={{
                      backgroundColor: ALL_COLORS[i % ALL_COLORS.length],
                    }}
                  />
                ))}
              </Stack>
              <div className="flex justify-end mt-2 text-[#56CCF2]">
                <button
                  onClick={() => handleFlip(index)}
                  className="underline focus:outline-none"
                >
                  View Details
                </button>
              </div>
            </Box>

            <Box
              className={` bg-gray-700 text-white p-6 mt-4 ${
                width < 850 ? "" : "mr-4"
              } rounded-lg h-70 shadow-lg ${flipped[index] ? "" : "hidden"}`}
            >
              <List className="text-white">
                {item.description.map((desc, i) => (
                  <li
                    className="flex flex-row justify-center items-center"
                    key={i}
                  >
                    <ArrowRightIcon className="text-white" />
                    <p className="font-sans text-base my-2">{desc}</p>
                  </li>
                ))}
              </List>
              <div className="flex justify-end mt-2 text-[#56CCF2]">
                <button
                  onClick={() => handleBack(index)}
                  className="underline focus:outline-none"
                >
                  Back
                </button>
              </div>
            </Box>
          </div>
        ))}
      </div>
    </Box>
  );
}

export default ProjectsNew;
